import { render, staticRenderFns } from "./histogram1.vue?vue&type=template&id=18f3da0b&scoped=true&"
import script from "./histogram1.vue?vue&type=script&lang=js&"
export * from "./histogram1.vue?vue&type=script&lang=js&"
import style0 from "./histogram1.vue?vue&type=style&index=0&id=18f3da0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f3da0b",
  null
  
)

export default component.exports